import styled from 'styled-components';

export const SelectorLeftContainer = styled.div`
    flex: 1;
    border: 1px solid ${props => props.theme.whiteGrey};
    padding: 20px 0px;
    display: flex;
    flex-direction: column;
    background-color: ${props => props.theme.whiteFog};

    & > p > span {
        font-size: 16px;
        font-weight: bold;
    }

    & > p {
        font-size: 16px;
        text-align: center;
    }

    .availability {
        font-size: 14px;
        font-style: italic;
        margin-top: 20px;
        min-height: 20px;
    }

    .ebon-selector-container {
        padding: 20px 20px 0 20px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .availability-color {
        color: ${props => props.theme.partnerCardEbonAvailabilityDateColor};
    }

    .error-area {
        padding: 10px 0 15px;
        color: ${props => props.theme.error};
        font-style: italic;
    }

    .resum-area {
        width: 100%;
        min-height: 71px;
        background-color: ${props => props.theme.white};
        border: 1px solid ${props => props.theme.whiteGrey};
        color: ${props => props.theme.primary};
        font-style: italic;
        padding: 5px 10px;
    }

    .quantity-selector {
        display: flex;
        margin: 20px 0;
        align-items: center;

        & > p {
            font-weight: bold;
            font-size: 16px;
        }
    }

    .quantity-button {
        display: flex;
        align-items: center;
        background-color: ${props => props.theme.white};
        margin-left: 10px;
        width: 136px;
        height: 47px;
        border: 1px solid ${props => props.theme.whiteGrey};
        justify-content: space-between;

        & > div {
            border-left: 1px solid ${props => props.theme.whiteGrey};
            border-right: 1px solid ${props => props.theme.whiteGrey};
            height: 100%;
            flex: 4;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        & > button {
            background-color: ${props => props.theme.white};
            border: none;
            flex: 2;
            font-size: 25px;
            color: ${props => props.theme.inactive};
            padding-bottom: 5px;
            cursor: pointer;
        }
    }

    .none-selected {
        color: ${props => props.theme.primary};
        background-color: ${props => props.theme.white};
    }

    @media (max-width: ${props => props.theme.mobile}) {
        .valueTips {
            padding: 0 20px;
        }

        .availability {
            min-height: 40px;
            display: flex;
            align-items: center;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/ebonselector/EbonSelectorLeftContainerStyle.js